import { Route, Routes } from "react-router-dom";
import { employer } from "../globals/route-names";
import EmpDashboardPage from "../app/pannels/employer/components/emp-dashboard";
import EmpCompanyProfilePage from "../app/pannels/employer/components/emp-company-profile";
import EmpCompaniesPage from "../app/pannels/employer/components/emp-companies";
import EmpPostAJobPage from "../app/pannels/employer/components/jobs/emp-post-a-job";
import EmpManageJobsPage from "../app/pannels/employer/components/jobs/emp-manage-jobs";
import EmpCandidatesPage from "../app/pannels/employer/components/emp-candidates";
import EmpBookmarksPage from "../app/pannels/employer/components/emp-bookmarks";
import EmpMessages1Page from "../app/pannels/employer/components/messages/emp-messages1";
import EmpMessages2Page from "../app/pannels/employer/components/messages/emp-messages2";
import EmpResumeAlertsPage from "../app/pannels/employer/components/emp-resume-alerts";
import SupportTicketsPage from "../app/common/support-tickets";
import Error404Page from "../app/pannels/public-user/components/pages/error404";

function EmployerRoutes() {
    return (
        <Routes>
            <Route path={employer.DASHBOARD} element={<EmpDashboardPage />} />
            <Route path={employer.PROFILE} element={<EmpCompanyProfilePage />} />
            <Route path={employer.COMPANIES} element={<EmpCompaniesPage />} />
            <Route path={employer.POST_A_JOB} element={<EmpPostAJobPage />} />
            <Route path={employer.EDIT_JOB} element={<EmpPostAJobPage />} />
            <Route path={employer.MANAGE_JOBS} element={<EmpManageJobsPage />} />
            <Route path={employer.CANDIDATES} element={<EmpCandidatesPage />} />
            <Route path={employer.BOOKMARKS} element={<EmpBookmarksPage />} />
            <Route path={employer.MESSAGES1} element={<EmpMessages1Page />} />
            <Route path={employer.MESSAGES2} element={<EmpMessages2Page />} />
            <Route path={employer.RESUME_ALERTS} element={<EmpResumeAlertsPage />} />
            <Route path={employer.SUPPORT} element={<SupportTicketsPage title="Employer Support" subtitle="Raise support tickets and view admin replies" />} />
            <Route path="*" element={<Error404Page />} />
        </Routes>
    )
}

export default EmployerRoutes;
